"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var validatedViewModel_1 = require("./base/validatedViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        _super.call(this, options);
        this.fio = ko.observable().extend({
            required: true,
            maxLength: 50,
            minLength: 2
        });
        this.email = ko.observable().extend({
            required: true,
            email: true,
            validation: {
                async: true,
                validator: function (val, params, callback) {
                    ajaxUtils_1.AjaxUtils.get("account/checkIfEmailExists", {
                        email: val
                    })
                        .done(function (result) {
                        if (!result.isSuccessful) {
                            callback({ isValid: result.data, message: result.messages.toString() });
                        }
                        else {
                            callback(result.data);
                        }
                    });
                },
                message: "Пользователь с такой электронной почтой уже зарегистрирован."
            }
        });
        this.password = ko.observable().extend({ required: true });
        this.termsAgree = ko.observable(false);
        this.initValidation();
    }
    ViewModel.prototype.onSubmitSucess = function (result) {
        this.redirectToPage(result.data.redirectUrl);
    };
    return ViewModel;
}(validatedViewModel_1.default));
;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=accountRegister.js.map